import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'gardenSoil',
      d: 'M0,-1h0.5v0.5h-0.5zM-1.5,-0.5h1v0.5h-1zM0,-0.5h1v0.5h-1zM-2,0h4.5v0.5h-4.5z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['wheat', 0.78],
      ],
      d: 'M-0.5,-4h0.5v2h-0.5zM-2,-3.5h0.5v0.5h-0.5zM1,-3.5h1v1h-1zM-3,-3h1.5v1h-1.5zM0.5,-2.5h1.5v0.5h-1.5zM-2.5,-2h1v0.5h-1zM-0.5,-2h2.5v0.5h-2.5zM-2,-1.5h0.5v1.5h-0.5zM-0.5,-1.5h1v0.5h-1zM1,-1.5h1v1.5h-1zM-0.5,-1h0.5v1h-0.5z',
    },
    {
      paint: 'wheat',
      d: 'M-0.5,-6h0.5v0.5h-0.5zM-2,-5.5h0.5v0.5h-0.5zM-1,-5.5h0.5v0.5h-0.5zM0,-5.5h0.5v0.5h-0.5zM1,-5.5h0.5v0.5h-0.5zM-2.5,-5h1v0.5h-1zM-0.5,-5h1v1h-1zM1,-5h1v1.5h-1zM-2.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['snowCap', 0.3],
        ['wheat', 0.7],
      ],
      d: 'M-0.5,-5.5h0.5v0.5h-0.5zM-2,-4.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 75,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'gardenSoil',
      d: 'M-0.5,-1h0.5v1h-0.5zM0.5,-0.5h0.5v0.5h-0.5zM1.5,-0.5h0.5v0.5h-0.5zM-2,0h4.5v0.5h-4.5z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['wheat', 0.78],
      ],
      d: 'M-1,-4h0.5v0.5h-0.5zM1,-4h0.5v1.5h-0.5zM-2,-3.5h1.5v0.5h-1.5zM0,-3.5h0.5v1h-0.5zM-3,-3h2.5v1h-2.5zM2,-3h0.5v3h-0.5zM0,-2.5h1.5v1h-1.5zM-2.5,-2h2v2h-2zM0,-1.5h0.5v1.5h-0.5zM1,-1.5h0.5v1.5h-0.5z',
    },
    {
      paint: 'wheat',
      d: 'M-1,-6h0.5v0.5h-0.5zM-1.5,-5.5h1.5v0.5h-1.5zM1,-5.5h1v0.5h-1zM-2,-5h1.5v0.5h-1.5zM0,-5h1.5v0.5h-1.5zM2,-5h0.5v0.5h-0.5zM-2.5,-4.5h2.5v0.5h-2.5zM0.5,-4.5h1v0.5h-1zM2,-4.5h1v0.5h-1zM-2.5,-4h1v0.5h-1zM-0.5,-4h1.5v0.5h-1.5zM1.5,-4h1.5v0.5h-1.5zM-2.5,-3.5h0.5v0.5h-0.5zM-0.5,-3.5h0.5v0.5h-0.5zM1.5,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['snowCap', 0.3],
        ['wheat', 0.7],
      ],
      d: 'M0.5,-5.5h0.5v0.5h-0.5zM-2.5,-5h0.5v0.5h-0.5zM0,-4.5h0.5v0.5h-0.5zM1.5,-4.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 104,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'gardenSoil',
      d: 'M-0.5,-1h0.5v0.5h-0.5zM-2,-0.5h0.5v0.5h-0.5zM-1,-0.5h1v0.5h-1zM0.5,-0.5h1v0.5h-1zM-2,0h2v0.5h-2zM0.5,0h2v0.5h-2z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['wheat', 0.78],
      ],
      d: 'M-1.5,-1.5h0.5v1.5h-0.5zM1,-1.5h1v1h-1zM-3,-1h1v1h-1zM0,-1h0.5v1.5h-0.5zM1.5,-0.5h1.5v0.5h-1.5zM-2.5,0h0.5v0.5h-0.5zM2.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['snowCap', 0.3],
        ['wheat', 0.7],
      ],
      d: 'M-1.5,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM-3,-1.5h1v0.5h-1zM-1,-1.5h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM2,-1h1v0.5h-1z',
    },
  ],
  pixels: 41,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
